import { FC } from "react";
import { FullScreenMaskProps } from "../../../interfaces";
import { QrTypes } from "../../../enums";
import { ActiveScanner } from "../activeScanner/ActiveScanner";
import { QrStatus } from "../qrStatus/QrStatus";
import { makeStyles } from '@mui/styles';
import colors from "../../../../../common/styles/colors";

const useStyles = makeStyles({
  container: (props: { shouldUpdateStyles?: boolean }) => ({
    width: `calc(100% - ${props.shouldUpdateStyles ? '200px' : '9px'})`,
    height: `calc(100% - ${props.shouldUpdateStyles ? '94px' : '9px'})`,
    margin: props.shouldUpdateStyles ? "auto" : "0",
    borderRadius: 15,
    border: "5px solid transparent",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }),
  fullscreenMaskIconError: {
    backgroundColor: colors.lightRedColor
  },
  fullscreenMaskIconSuccess: {
    backgroundColor: colors.lightGreenColor
  },
  fullscreenMaskSuccess: {
    borderColor: `${colors.lightGreenColor} !important`,
    "@media screen and (max-width: 447px)": {
      borderRadius: 0
    },
  },
  fullscreenMaskError: {
    borderColor: `${colors.lightRedColor} !important`,
    "@media screen and (max-width: 447px)": {
      borderRadius: 0
    },
  }
});

export const FullScreenMask: FC<FullScreenMaskProps> = ({ type, shouldUpdateStyles }) => {
  const classes = useStyles({ shouldUpdateStyles });
  const getClassesNameByType = () => {
    if (type === QrTypes.ERROR) {
      return { wrapperClassName: classes.fullscreenMaskError, iconClassName: classes.fullscreenMaskIconError };
    }
    if (type === QrTypes.SUCCESS) {
      return { wrapperClassName: classes.fullscreenMaskSuccess, iconClassName: classes.fullscreenMaskIconSuccess };
    }
    return { wrapperClassName: "", iconClassName: "" };
  };

  const { wrapperClassName, iconClassName } = getClassesNameByType();

  return (
    <div className={`${classes.container} ${wrapperClassName}`} data-testid="full-screen-wrapper">
      {(type === QrTypes.SCANNING && !shouldUpdateStyles) ? <ActiveScanner /> : <QrStatus iconClassName={iconClassName} type={type} />}
    </div>
  );
};
